import { render, staticRenderFns } from "./ListDynamicRoutes.vue?vue&type=template&id=2a5151b2&"
import script from "./ListDynamicRoutes.vue?vue&type=script&lang=js&"
export * from "./ListDynamicRoutes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports